export const issueTypes = [
  { label: "Violencia familiar", value: "DOMESTIC_VIOLENCE" },
  { label: "Adicciones", value: "ADDICTIONS" },
  { label: "Fomento de cultura de denuncia", value: "COMPLAINT_CULTURE" },
  { label: "Estado de derecho", value: "STATE_LAW" },
  { label: "Cultura de la legalidad", value: "LEGAL_CULTURE" },
  { label: "Participación ciudadana", value: "CITIZEN_PARTICIPATION" },
  { label: "Dignificación de la labor policial", value: "OFFICER_DIGNIFICATION" },
  { label: "Incidencia en políticas públicas", value: "PUBLIC_POLICIES" },
  { label: "Prevención situacional", value: "SITUATIONAL_PREVENTION" },
  { label: "Prevención comunitaria", value: "COMMUNITY_PREVENTION" },
  { label: "Reinserción social", value: "SOCIAL_REINSERTION" },
  { label: "Violencia sexual", value: "SEXUAL_VIOLENCE" },
  { label: "Capacitación", value: "TRAINING" },
  { label: "Suicidio", value: "SUICIDE" },
  { label: "Deserción escolar", value: "ACADEMIC_DROPOUT" },
  { label: "Generadores de violencia", value: "VIOLENCE_GENERATORS" },
  { label: "Combate a la corrupción", value: "CORRUPTION_COMBAT" },
  { label: "Otro", value: "OTHER" },
  {
    label: "Adicciones",
    value: "ADDICTIONS"
  },
  {
    label: "Atención de factores de riesgo",
    value: "ATTENTION_OF_RISK_FACTORS"
  },
  {
    label: "Capacidades institucionales débiles",
    value: "WEAK_INSTITUTIONAL_CAPACITIES"
  },
  {
    label: "Corrupción",
    value: "CORRUPTION"
  },
  {
    label: "Deficiencias en el uso de tecnología y sistematización de la información",
    value: "TECNOLOGY_APPLICATION_DEFICIT"
  },
  {
    label: "Deficiencias en la impartición de justicia",
    value: "JUSTICE_ADMINISTRATION_DEFICIT"
  },
  {
    label: "Delincuencia",
    value: "DELINCUENCY"
  },
  {
    label: "Desconfianza en las autoridades",
    value: "AUTHORITIES_DISTRUST"
  },
  {
    label: "Desempleo",
    value: "UNEMPLOYMENT"
  },
  {
    label: "Desigualdad",
    value: "INEQUALITY"
  },
  {
    label: "Inseguridad",
    value: "INSECURITY"
  },
  {
    label: "Machismo y violencia contra la mujer",
    value: "SEXISM_AND_VIOLENCE_AGAINST_WOMAN"
  },
  {
    label: "Poca transparencia y rendición de cuentas",
    value: "LOW_TRANSPARENCY_AND_ACCOUNTABILITY"
  }
]

export const activeIssueTypes = [
  {
    label: "Adicciones",
    value: "ADDICTIONS"
  },
  {
    label: "Atención de factores de riesgo",
    value: "ATTENTION_OF_RISK_FACTORS"
  },
  {
    label: "Capacidades institucionales débiles",
    value: "WEAK_INSTITUTIONAL_CAPACITIES"
  },
  {
    label: "Corrupción",
    value: "CORRUPTION"
  },
  {
    label: "Deficiencias en el uso de tecnología y sistematización de la información",
    value: "TECNOLOGY_APPLICATION_DEFICIT"
  },
  {
    label: "Deficiencias en la impartición de justicia",
    value: "JUSTICE_ADMINISTRATION_DEFICIT"
  },
  {
    label: "Delincuencia",
    value: "DELINCUENCY"
  },
  {
    label: "Desconfianza en las autoridades",
    value: "AUTHORITIES_DISTRUST"
  },
  {
    label: "Desempleo",
    value: "UNEMPLOYMENT"
  },
  {
    label: "Desigualdad",
    value: "INEQUALITY"
  },
  {
    label: "Inseguridad",
    value: "INSECURITY"
  },
  {
    label: "Machismo y violencia contra la mujer",
    value: "SEXISM_AND_VIOLENCE_AGAINST_WOMAN"
  },
  {
    label: "Poca transparencia y rendición de cuentas",
    value: "LOW_TRANSPARENCY_AND_ACCOUNTABILITY"
  },
  {
    label: "Violencia Familiar",
    value: "DOMESTIC_VIOLENCE"
  }
]

export const inactiveIssueTypes = [
  { label: "Borrar selección", value: null },
  { label: "Violencia familiar", value: "DOMESTIC_VIOLENCE" },
  { label: "Adicciones", value: "ADDICTIONS" },
  { label: "Fomento de cultura de denuncia", value: "COMPLAINT_CULTURE" },
  { label: "Estado de derecho", value: "STATE_LAW" },
  { label: "Cultura de la legalidad", value: "LEGAL_CULTURE" },
  { label: "Participación ciudadana", value: "CITIZEN_PARTICIPATION" },
  { label: "Dignificación de la labor policial", value: "OFFICER_DIGNIFICATION" },
  { label: "Incidencia en políticas públicas", value: "PUBLIC_POLICIES" },
  { label: "Prevención situacional", value: "SITUATIONAL_PREVENTION" },
  { label: "Prevención comunitaria", value: "COMMUNITY_PREVENTION" },
  { label: "Reinserción social", value: "SOCIAL_REINSERTION" },
  { label: "Violencia sexual", value: "SEXUAL_VIOLENCE" },
  { label: "Capacitación", value: "TRAINING" },
  { label: "Suicidio", value: "SUICIDE" },
  { label: "Deserción escolar", value: "ACADEMIC_DROPOUT" },
  { label: "Generadores de violencia", value: "VIOLENCE_GENERATORS" },
  { label: "Combate a la corrupción", value: "CORRUPTION_COMBAT" },
  { label: "Otro", value: "OTHER" }
]